// noinspection JSCheckFunctionSignatures

import React, {useEffect} from "react";
import AuthRoute from "@common/components/auth/AuthRoute";
import AuthProvider from "@common/contexts/auth/AuthProvider";
import {Helmet} from "react-helmet-async";
import {Switch} from "react-router-dom";
import Layout from "./components/layout/Layout";
import {registerPushDevice} from "@common/utils/app/appBridge";
import {
  addMessageListener,
  isMobileAndroidApp,
  isMobileApp,
  isMobileIosApp,
  removeMessageListener,
} from "../common/utils/app/appUtils";
import WebviewMessage, {RN_APP_API_TYPE} from "../common/components/appConnect/WebviewMessage";
import {getAdicAccessToken, getAdicUserInfo, signOutAuth} from '@common/services/restapi/auth';
import {convertPath, convertHttpUrl} from "@common/utils/path/linkPath";
import channelTalk from "@common/utils/channelTalk/channelTalk"
// styles
import "./assets/scss/styles.scss";

const HOME_PAGE = "/";
const SIGN_IN_PAGE = convertPath("/login");

const loading = null;

if (isMobileApp()) {
  channelTalk.initialize();
}

function App() {

  const appListener = (event) => {
    if (event && event.data) {
      try {
        const { data: listenerData, reqId: listenerReqId, type: listenerType } = JSON.parse(event.data);
        if (RN_APP_API_TYPE.CHANGE_PUSH_PERMISSION === listenerType) {
          if (isMobileAndroidApp()) {
            if (
              listenerData.from.areNotificationsEnabled === false &&
              listenerData.to.areNotificationsEnabled === true
            ) {
              (async () => {
                await registerPushDevice();
              })();
            }
          } else if (isMobileIosApp()) {
            if (listenerData.from.status === 1 && listenerData.to.status === 2) {
              (async () => {
                await registerPushDevice();
              })();
            }
          }
        }
      } catch (e) {
        return false;
      }
    }
  };

  const appGlobalListener = (event) => {
    if (event && event.data) {
      try {
        const { data: listenerData, reqId: listenerReqId, type: listenerType } = JSON.parse(event.data);
        if (RN_APP_API_TYPE.MOVE_PUSH_LINK === listenerType) {
          if (listenerData && listenerData.app_link) {
            location.href = convertPath(listenerData.app_link);
          }
        } else if (RN_APP_API_TYPE.MOVE_DEEP_LINK === listenerType) {
          if (listenerData) {
            const urlParams = listenerData.replace(/adicapp:\/\//g, "");
            let urlSearchParams = new URLSearchParams(urlParams);
            const url = urlSearchParams.get("url");
            location.href = url;
          }
        } else if (RN_APP_API_TYPE.OPEN_CONFIRM_ALERT === listenerType) {
          if (
            listenerData &&
            listenerData.alertType === RN_APP_API_TYPE.OPEN_SETTINGS &&
            listenerData.result === "confirm"
          ) {
            (async () => {
              await WebviewMessage(RN_APP_API_TYPE.OPEN_SETTINGS, null).catch(() => null);
            })();
          }
        } else if (RN_APP_API_TYPE.GO_BACK === listenerType) {
          history.goBack();
        }
      } catch (e) {
        return false;
      }
    }
  };

  useEffect(() => {
    addMessageListener(appListener);
    addMessageListener(appGlobalListener);
    return () => {
      removeMessageListener(appListener);
      removeMessageListener(appGlobalListener);
    };
  }, []);

  const handleSignIn = async (provider, accessToken) => {
    return await getAdicAccessToken(provider, accessToken);
  };

  const handleCheckAuthFailed = () => {
    // location.href = HOME_PAGE;
  };

  const redirectToSignIn = () => {
    location.href = convertHttpUrl(location.protocol + "//" + location.host + SIGN_IN_PAGE);
  };

  const handleSignInFailed = () => {
    // location.href = HOME_PAGE;
    alert('로그인에 대한 처리가 완료되지 못하였습니다. 다시 로그인을 진행하시기 바랍니다.');
    location.href = convertHttpUrl(location.protocol + "//" + location.host + convertPath('/login'));
  };

  const redirectAfterSignIn = (redirectUrl) => {
    if (redirectUrl) {
      let mainUrl = convertHttpUrl(location.protocol + "//" + location.host + convertPath(""));
      let convertRedirectUrl = convertHttpUrl(redirectUrl);
      location.href = !convertRedirectUrl || convertRedirectUrl.includes('login') ? mainUrl : convertRedirectUrl;
    }
  };

  const handleSignInSuccess = (successResult) => {
    console.log("successResult  = ",successResult);
    // if (isMobileApp()) {
    //   (async () => {
    //     await registerPushDevice();
    //   })();
    // }
  };

  const handleSignOutSuccess = (successResult) => {
    console.log("successResult  = ",successResult);
    location.href = convertHttpUrl(location.protocol + "//" + location.host + convertPath(""));
  };

  const handleCheckAuthSuccess = () => {
    if (location.href.includes("login")) {
      location.href = convertHttpUrl(location.protocol + "//" + location.host + convertPath("/mypage"));
    }
  };

  const handleUserDataFetch = async (provider) => {
    return await getAdicUserInfo(provider);
  };

  const handleSignOut = async () => {
    return await signOutAuth();
  };

  return (
    <React.Suspense fallback={loading}>
      <AuthProvider
        appId="adic"
        onSignIn={handleSignIn}
        redirectToSignIn={redirectToSignIn}
        redirectAfterSignIn={redirectAfterSignIn}
        onCheckAuthFailed={handleCheckAuthFailed}
        onCheckAuthSuccess={handleCheckAuthSuccess}
        onSignInSuccess={handleSignInSuccess}
        onSignInFailed={handleSignInFailed}
        onSignOutSuccess={handleSignOutSuccess}
        onUserDataFetch={handleUserDataFetch}
        onSignOut={handleSignOut}
      >
        <Helmet>
          <title>광고정보센터</title>
        </Helmet>
        <Switch>
          <AuthRoute path={HOME_PAGE} component={Layout} />
        </Switch>
      </AuthProvider>
    </React.Suspense>
  );
}

export default App;
